import styled from 'styled-components';

import { Text } from 'components/common';

export const ResetEmployee = styled(Text)`
  border-bottom: 1px dotted #999ea6;
  text-decoration: none;
`;
